import { createAction } from 'redux-act'
import { replace } from 'react-router-redux'
import queryString from 'query-string'

export const update = createAction('events-filters/update')

const filterKeys = ['guests', 'dates', 'location', 'tag']

export const syncFiltersAction = () => (dispatch, getState) => {
  const { eventsFilters } = getState()
  const query = queryString.parse(window.location.search)

  const mergedFilters = {}
  for (const filter of filterKeys) {
    const maybeValue = query[filter] || eventsFilters[filter]

    try {
      const value = JSON.parse(maybeValue)
      if (value.from) {
        value.from = new Date(value.from)
      }
      if (value.to) {
        value.to = new Date(value.to)
      }
      dispatch(update({ filter, value }))
    } catch (e) {
      dispatch(update({ filter, value: maybeValue }))
    }

    mergedFilters[filter] = typeof maybeValue === 'object'
      ? JSON.stringify(maybeValue)
      : maybeValue
  }

  const newQuery = Object.assign(query, mergedFilters)
  const url = `${window.location.pathname}?${queryString.stringify(newQuery)}`
  dispatch(replace(url))
}

export const updateAction = (filter, value) => (dispatch) => {
  dispatch(update({ filter, value }))

  const query = queryString.parse(window.location.search)
  const urlValue = typeof value === 'object'
    ? JSON.stringify(value)
    : value
  Object.assign(query, { [filter]: urlValue })

  const url = `${window.location.pathname}?${queryString.stringify(query)}`
  dispatch(replace(url))
}
